import React, { useEffect, useState, useCallback, useContext } from 'react';
import { Grid, Paper, Typography, Button, Box } from '@mui/material';
import { useApiBaseUrl } from '../context/ApiContext';
import DeleteIcon from '@mui/icons-material/Delete';
import LinearProgress from '@mui/material/LinearProgress';
import OrderEdit from './orderEdit';
import { EditingContext } from './EditingContext';

// Deposit item nos. to exclude from product/order line display (not orderable as products)
const PALLET_DEPOSIT_ITEM_NOS = ['D-000006', 'D-000008', 'D-000017'];

const OrderDetails = ({orderId, SelectedCustomerId, OrderCycleInfo, usernameEmail, handleOrderDeleted}) => {

  const ApiBaseUrl = useApiBaseUrl();
  useEffect(() => {
    console.log('redering component')
    console.log('orderId:', orderId);
    console.log('SelectedCustomerId:', SelectedCustomerId);
    console.log('locationCode:', locationCode);
  }, []);

  const [orderHeaderData, setOrderHeaderData] = useState(null);
  const [orderLinesData, setOrderLinesData] = useState(null);
  const [AuthorizedItems, setAuthorizedItems] = useState(null);
  const [locationCode, setLocationCode] = useState(null);
  const [showAddItems, setShowAddItems] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [reviewingOrder, setReviewingOrder] = useState(false);
  const [OpenPreOrderItems, setOpenPreOrderItems] = useState([]);
  const [ShowOrderSubmmited, setShowOrderSubmmited] = useState(false);
  const [SubmittingOrder, setSubmittingOrder] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  //const [isEditing, setIsEditing] = useState(false);
  const { isEditing, setIsEditing } = useContext(EditingContext);
  const { forRealEditing, setForRealEditing } = useContext(EditingContext);
  const [totalOrderWeight, setTotalOrderWeight] = useState(0);
  const [totalPalletsNeeded, setTotalPalletsNeeded] = useState('0.00');

  useEffect(() => {
    const calculateTotalWeight = () => {
      try {
        if (!AuthorizedItems) {
          console.warn('AuthorizedItems is not set');
          return;
        }
        let total = 0;
        selectedItems.forEach(item => {
          const authorizedItem = AuthorizedItems.find(ai => ai.no_ === item.no_);
          if (authorizedItem && item.qty && item.uom) {
            const totalUnits = calculateTotalUnits(authorizedItem, item.qty, item.uom);
            total += authorizedItem.weight * totalUnits;
          }
        });
        setTotalOrderWeight(total.toFixed(2));
      } catch (error) {
        console.error('Error calculating total weight:', error);
      }
    };
    calculateTotalWeight();
  }, [selectedItems, AuthorizedItems]);

  useEffect(() => {
    const calculateTotalPalletsNeeded = () => {
      try {
        if (!AuthorizedItems) {
          setTotalPalletsNeeded('0.00');
          return;
        }

        let totalPallets = 0;

        selectedItems.forEach(item => {
          const authorizedItem = AuthorizedItems.find(ai => ai.no_ === item.no_);
          if (!authorizedItem || !item.qty || !item.uom) {
            return;
          }

          const qtyPerPallet = parseFloat(authorizedItem.qtyPerPalletNotDivided);
          if (!qtyPerPallet) {
            return;
          }

          const totalUnits = calculateTotalUnits(authorizedItem, parseFloat(item.qty), item.uom);
          totalPallets += totalUnits / qtyPerPallet;
        });

        setTotalPalletsNeeded(totalPallets.toFixed(2));
      } catch (error) {
        console.error('Error calculating total pallets needed:', error);
        setTotalPalletsNeeded('0.00');
      }
    };

    calculateTotalPalletsNeeded();
  }, [selectedItems, AuthorizedItems]);
  // Log selected items
  useEffect(() => {
    //alert('selectedItems updated');
    console.log('selectedItems:', JSON.stringify(selectedItems, null, 2));
    // if (isEditing) {
    //   fetchOrderHeader();
    // }
  }, [selectedItems]);


  useEffect(() => {
    //if selectedItems is empty, fetch order header and order lines and set selectedItems to the order lines, making sure to filter out the pallet deposit items
    //also this should only happening when editing
    if (selectedItems.length === 0 && isEditing) {
      const fetchOrderHeader = async () => {
      try {
        setIsLoading(true);

        setShowAddItems(false);
        
        //await new Promise(resolve => setTimeout(resolve, 8000));
        const response = await fetch(`${ApiBaseUrl}/api/sales/${orderId}/OrderPortal_Get_OrderHeader_ByOrderId`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log('Order header data:', data);
        try {
          console.log('locationCode:', data.header.warehouseLocation);
          setLocationCode(data.header.warehouseLocation);
        }

        catch (error) {
          console.error('Error setting location code:', error);
        }
        await setOrderHeaderData(data.header);
        await setOrderLinesData(data.lines);


        if (!data.lines.length > 0) {
          await setShowAddItems(true);
        }
        setIsLoading(false);

      } catch (error) {
        console.error('Error fetching order details:', error);
      }
    };
      setSelectedItems(orderLinesData.filter(item => !PALLET_DEPOSIT_ITEM_NOS.includes(item.no_)));
    }
  }, [selectedItems]);
  
  // Fetch open pre-order items
  // ----- the function call surrounded by the if (orderId) below is already commented out, so this is unnecessary anyway
  // useEffect(() => {
  //   const fetchOpenPreOrderItems = async () => {
  //     try {
  //       const response = await fetch(`${ApiBaseUrl}/api/sales/${SelectedCustomerId}/OpenPreOrderItemQuantities_ByCustomerId`);
  //       const data = await response.json();
  //       setOpenPreOrderItems(data);
  
  //       // Merge OpenPreOrderItems with selectedItems
  //       setSelectedItems(prevSelectedItems => {
  //         const newSelectedItems = data.map(preOrderItem => ({
  //           no_: preOrderItem.no_,
  //           qty: preOrderItem.preOrderQty,
  //           uom: 'PIECE' // Assuming 'PIECE' as the default UOM for pre-order items
  //         }));
  
  //         // Merge newSelectedItems with prevSelectedItems, avoiding duplicates
  //         const mergedItems = [...prevSelectedItems];
  //         newSelectedItems.forEach(newItem => {
  //           const existingItemIndex = mergedItems.findIndex(item => item.no_ === newItem.no_);
  //           if (existingItemIndex > -1) {
  //             mergedItems[existingItemIndex] = newItem;
  //           } else {
  //             mergedItems.push(newItem);
  //           }
  //         });
  
  //         return mergedItems;
  //       });
  //     } catch (error) {
  //       console.error('Error fetching open pre-order items:', error);
  //     }
  //   };
  
  //   if (orderId) {
  //     //fetchOpenPreOrderItems();
  //   }
  // }, [orderId, SelectedCustomerId]);


  const handleInputChange = (item, event) => {
    console.log('handleInputChange', item, event);
    const value = event.target.value;
    
    // Return early if value is negative or 0
    if (parseFloat(value) <= 0) {
      return;
    }
    
    const selectedUOM = document.getElementById(`select-${item.no_}`).value;
    
    setSelectedItems(prevSelectedItems => {
      const existingItem = prevSelectedItems.find(i => i.no_ === item.no_);
      if (existingItem) {
        if (value === '') {
          // Remove the item if the value is empty
          return prevSelectedItems.filter(i => i.no_ !== item.no_);
        } else {
          // Update the item if it exists and value is positive
          return prevSelectedItems.map(i =>
            i.no_ === item.no_ ? { ...i, qty: value, uom: selectedUOM, brewery: item.brewery, description: item.description } : i
          );
        }
      } else {
        if (value === '' || value === '0') {
          // Do nothing if the value is empty/0 and the item does not exist
          return prevSelectedItems;
        } else {
          // Add the item if it does not exist and value is positive
          return [...prevSelectedItems, { no_: item.no_, qty: value, uom: selectedUOM, brewery: item.brewery, description: item.description }];
        }
      }
    });
  };



  const handleReviewClick = () => {
    // Validation step
    const invalidItems = selectedItems.filter(item => (item.qty && !item.uom) || (!item.qty && item.uom));
    if (invalidItems.length > 0) {
      setInvalidItems(invalidItems.map(item => item.no_));
      setSubmittingOrder(false);
      return;
    }
    // Reset invalid items if validation passes
    setInvalidItems([]);
    setReviewingOrder(true);
  };

  const handleContinueEditingClick = () => {
    setReviewingOrder(false);
  };

  const [invalidItems, setInvalidItems] = useState([]);

  const calculatePalletDeposit = (item, AuthorizedItems) => {
    const authorizedItem = AuthorizedItems.find(authItem => authItem.no_ === item.no_);
    if (!authorizedItem) return 0;
  
    let palletCount = 0;
    const qty = parseInt(item.qty, 10);
  
    switch (item.uom) {
      case 'PALLET':
        palletCount = qty;
        break;
      case 'LAYER':
        const LayerPalletFactor = authorizedItem.qtyPerLayerNotDivided / authorizedItem.qtyPerPalletNotDivided;
        palletCount = qty * LayerPalletFactor;
        break;
      case 'PIECE':
        palletCount = qty / authorizedItem.qtyPerPalletNotDivided;
        break;
      default:
        palletCount = 0;
    }
  
    return Math.ceil(palletCount);
  };  

  const handleSubmitOrderClick = async () => {
    //clear isEditing session var
    sessionStorage.removeItem('isEditing');

    setSubmittingOrder(true);
    console.log('selectedItems:', selectedItems);


    const orderObjects = selectedItems.map((item, index) => {
      const baseObject = {
        DocumentNo_: parseInt(orderId, 10),
        LineNo_: (index + 1) * 1000,
        Type: 0,
        Klant: SelectedCustomerId,
        ItemNo_: item.no_,
        NumberOfUnits: parseFloat(calculateTotalUnits(AuthorizedItems.find(authItem => authItem.no_ === item.no_), parseInt(item.qty, 10), item.uom)) ,// * AuthorizedItems.find(authItem => authItem.no_ === item.no_)?.qtyPerPalletNotDivided,
        Pallets: 0,
        UnitPrice: 0,
        Price: 0,
        UnitOfMeasure: item.uom,
        Layers: 0,
        QtyperUnitofMeasure: 0,
        QuantityBase:  parseFloat(calculateTotalUnits(AuthorizedItems.find(authItem => authItem.no_ === item.no_), parseInt(item.qty, 10), item.uom)),// parseInt(item.qty, 10) * AuthorizedItems.find(authItem => authItem.no_ === item.no_)?.qtyPerPalletNotDivided,
        UnitofMeasureCode: item.uom || "",
        OrderType: item.orderType || 1,
        Description: item.description,
        Brewery: item.brewery
      };
    
      // Now add the calculated properties
      //AuthorizedItems.find(authItem => authItem.no_ === item.no_)?.qtyPerPalletNotDivided
      
      //baseObject.palletDeposit_calc =  parseInt(item.qty, 10) * AuthorizedItems.find(authItem => authItem.no_ === item.no_)?.qtyPerPalletNotDivided / AuthorizedItems.find(authItem => authItem.no_ === item.no_)?.qtyPerPalletNotDivided;
      baseObject.palletDeposit_calc = calculatePalletDeposit(item, AuthorizedItems);
      baseObject.pallet_deposit = AuthorizedItems.find(authItem => authItem.no_ === item.no_)?.palletDeposit || 0;
    
      return baseObject;
    });

    // D-000006 and D-000017 (contract) both sum into palletDeposits
    const totalPalletDepositCalc = {
      qty: orderObjects
        .filter(obj => obj.pallet_deposit === 'D-000006' || obj.pallet_deposit === 'D-000017')
        .reduce((sum, obj) => sum + obj.palletDeposit_calc, 0)
    };
    
    const totalPalletDepositCalc_free = {
      deposit: 'D-000008',
      qty: orderObjects
        .filter(obj => obj.pallet_deposit === 'D-000008')
        .reduce((sum, obj) => sum + obj.palletDeposit_calc, 0)
    };

    const totalPalletDepositCalc_D000020 = {
      deposit: 'D-000020',
      qty: orderObjects
        .filter(obj => obj.pallet_deposit === 'D-000020')
        .reduce((sum, obj) => sum + obj.palletDeposit_calc, 0)
    };

    const preOrderItemIds = selectedItems
        .filter(item => item.qty > 0)
        .map(item => {
          const preOrderItem = OpenPreOrderItems.find(preOrder => preOrder.no_ === item.no_);
          return preOrderItem ? preOrderItem.preOrderItemId : null;
        })
      .filter(id => id !== null);

    const model = {
      items: orderObjects,
      palletDeposits: totalPalletDepositCalc.qty,
      palletDeposits_free: totalPalletDepositCalc_free.qty,
      palletDeposits_D000020: totalPalletDepositCalc_D000020.qty,
      PreOrderItemIds: preOrderItemIds
    };

    console.log('requestBody:', model);
    try {
      const response = await fetch(`${ApiBaseUrl}/api/sales/${parseInt(orderId, 10)}/${isEditing}/InsertECommLines_ByOrderId_ByECommLineQueryModel`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(model)
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response;
      console.log('Order submitted successfully:', data);
      setShowOrderSubmmited(true);
      
    } catch (error) {
      
      console.error('0006 Error submitting order:', error);
    }

    const shipDate = new Date(orderHeaderData.requestedDeliveryDate).toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
    const decodedOrderNo = decodeURIComponent(orderHeaderData.yourOrderNo);
    console.log('orderHeaderData', orderHeaderData);
    console.log('decodedOrderNo:', decodedOrderNo);
    console.log('shipDate:', shipDate);
    console.log('model:', model);


    const strippedOrderObjects = orderObjects.map(item => ({
      ItemNo_: item.ItemNo_,
      Brewery: item.Brewery,
      Description: item.Description,
      NumberOfUnits: item.NumberOfUnits
    }));
  
    
    const confirmationModel = {
      items: strippedOrderObjects,
      custId: SelectedCustomerId
    };


    console.log('confirmationModel:', confirmationModel);

    
    if (orderHeaderData && Object.keys(orderHeaderData).length > 0) {
      console.log('orderId: ', parseInt(orderHeaderData.orderId))
      try {
        const newModel = {
          Items: model.items || [],
          // PalletDeposits: 0,
          // PalletDeposits_free: 0,
          email: usernameEmail || '',
          custId: SelectedCustomerId || '',
          custPO: orderHeaderData.yourOrderNo || '',
          // orderno: parseInt(orderHeaderData.orderId) || '',
          scheduledShipDate: shipDate,
          carrier: '',
          poolLoad: ''
        };
        console.log('sending confirmation....');
        console.log('newModel being sent:', newModel);
        console.log('carrier value (lowercase):', orderHeaderData.carrier);
        console.log('carrier value (capitalized):', orderHeaderData.Carrier);
        console.log('poolLoad value (lowercase):', orderHeaderData.poolLoad);
        console.log('poolLoad value (capitalized):', orderHeaderData.PoolLoad);
        console.log('orderHeaderData keys:', Object.keys(orderHeaderData));
        console.log('Full orderHeaderData:', JSON.stringify(orderHeaderData, null, 2));
        newModel.carrier = orderHeaderData.orderComment.split('|')[0].split(':')[1]; //parse the carrier value from orderHeaderData.orderComment "orderComment": "Carrier:ct4|PoolLoad:plt4"
        newModel.poolLoad = orderHeaderData.orderComment.split('|')[1].split(':')[1]; //parse the poolLoad value from orderHeaderData.orderComment "orderComment": "Carrier:ct4|PoolLoad:plt4"
        console.log('newModel.carrier:', newModel.carrier);
        console.log('newModel.poolLoad:', newModel.poolLoad);
        const requestBody = JSON.stringify(newModel);
        console.log('Request body being sent:', requestBody);
        var response = null;
        try {
           response = await fetch(`${ApiBaseUrl}/api/Sales/SendOrderConfirmationEmail`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
          },
          body: requestBody
        });
      
        } catch (error) {
          console.error('0004 Error sending confirmation:', error);
        }
        // if (!response.ok) {
        //   throw new Error('0005 Network response was not ok');
        // }
        const data = await response;
        console.log('Order submitted successfully:', data);
        setShowOrderSubmmited(true);
        
      } catch (error) {
        
        console.error('0003 Error submitting order:', error);
      }
    };
  };

  useEffect(() => {
    //alert('orderId: ' + orderId);
    //alert('orderId useEffect: ' + orderId);
    const fetchOrderHeader = async () => {
      try {
        setIsLoading(true);

        setShowAddItems(false);
        
        //await new Promise(resolve => setTimeout(resolve, 8000));
        const response = await fetch(`${ApiBaseUrl}/api/sales/${orderId}/OrderPortal_Get_OrderHeader_ByOrderId`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log('Order header data:', data);
        try {
          console.log('locationCode:', data.header.warehouseLocation);
          setLocationCode(data.header.warehouseLocation);
        }

        catch (error) {
          console.error('Error setting location code:', error);
        }
        await setOrderHeaderData(data.header);
        await setOrderLinesData(data.lines);


        if (!data.lines.length > 0) {
          await setShowAddItems(true);
        }
        setIsLoading(false);

      } catch (error) {
        console.error('Error fetching order details:', error);
      }
    };
    
    const init = async () => {
      if (orderId) {
        await new Promise(resolve => setTimeout(resolve, 1000));
        await fetchOrderHeader();
      }
    };

    init();
  }, [orderId]);

  // Modify the useEffect that depends on isEditing
  useEffect(() => {
    console.log('isEditing useEffect: ', isEditing);
    if (isEditing) {
      const fetchOrderHeader = async () => {
        console.log('fetchOrderHeader');
        try {
          const response = await fetch(`${ApiBaseUrl}/api/sales/${orderId}/OrderPortal_Get_OrderHeader_ByOrderId`);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const data = await response.json();
          console.log('Order header data:', data);
          setLocationCode(data.header.warehouseLocation);
          setOrderHeaderData(data.header);
          setOrderLinesData(data.lines);

          // Only set selectedItems if they haven't been set yet or are empty
          if (!selectedItems.length) {
            console.log('Setting selectedItems from order lines');
            const filteredLines = data.lines.filter(line =>
              !PALLET_DEPOSIT_ITEM_NOS.includes(line.itemNo_)
            );
            
            const newSelectedItems = filteredLines.map(line => ({
              no_: line.itemNo_,
              qty: line.numberOfUnits, // Use numberOfUnits instead of quantityBase
              uom: line.unitofMeasureCode,
              brewery: line.brewery,
              description: line.description
            }));
            
            setSelectedItems(newSelectedItems);
          }
        } catch (error) {
          console.error('Error fetching order header:', error);
        }
      };

      fetchOrderHeader();
    }
  }, [isEditing]); // Only depend on isEditing

  // Modify the useEffect that watches selectedItems
  useEffect(() => {
    console.log('selectedItems updated:', JSON.stringify(selectedItems, null, 2));
  }, [selectedItems]);

  // Add a new useEffect to handle AuthorizedItems fetching when editing
  // useEffect(() => {
  //   console.log('isEditing useEffect: ', isEditing);
  //   if (isEditing && locationCode) {
  //     fetchAuthorizedItems();
  //   }
  // }, [isEditing, locationCode]);

  const [orderTotalWeight, setOrderTotalWeight] = useState(0);
  const totalProductWeight =
    totalOrderWeight !== '0.00'
      ? parseFloat(totalOrderWeight)
      : parseFloat(orderHeaderData?.totalOrderWeight || 0);
  const palletsNeededValue = parseFloat(totalPalletsNeeded || 0);
  const roundedPalletsNeeded = Math.ceil(palletsNeededValue);
  const palletsWeight = roundedPalletsNeeded * 55;
  const recalculatedTotalOrderWeight = totalProductWeight + palletsWeight;

  const getTotalOrderWeight = async () => {
    try {
      const response = await fetch(`${ApiBaseUrl}/api/sales/${orderId}/GetTotalOrderWeight_ByOrderId`);
      console.log('total order weight:', response);
      setOrderTotalWeight(response);
    } catch (error) {
      console.error('Error fetching total order weight:', error);
    }
  }
  //OpenPreOrderItemQuantities_ByCustomerId

  const fetchAuthorizedItems = async () => {
    try {
      setShowAddItems(true);
      const response = await fetch(`${ApiBaseUrl}/api/sales/${SelectedCustomerId}/${locationCode}/GetAuthorizedItems_ByCustomerId_ByLocation`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setAuthorizedItems(data);

      // Only fetch pre-order items if not editing
      if (isEditing) {
        return
      }

      if (!isEditing) {
        await fetchOpenPreOrderItems();
      }

      setShowAddItems(true);
    } catch (error) {
      console.error('Error fetching authorized items:', error);
    }
  };

  const fetchOpenPreOrderItems = async () => {
    console.log('fetchOpenPreOrderItems, isEditing: ', isEditing);
    // if the order id does not start with SOR, return
    //timeout delay of 5 seconds
    //await new Promise(resolve => setTimeout(resolve, 5000));
    console.log('forRealEditing: ', forRealEditing);
    if (forRealEditing === true) {
      return;
    }
    //if statement that returns based on the session storage variable isEditing
    if (sessionStorage.getItem('isEditing') === 'true') {
      return;
    }
      try {
        console.log('fetching open pre-order items');
        const response = await fetch(`${ApiBaseUrl}/api/sales/${SelectedCustomerId}/OpenPreOrderItemQuantities_ByCustomerId`);
        const data = await response.json();
        setOpenPreOrderItems(data);

        // Update selectedItems with pre-order data
        setSelectedItems(data.map(preOrderItem => ({
          no_: preOrderItem.no_,
          qty: preOrderItem.preOrderQty,
          uom: 'PIECE', // Assuming 'PIECE' as the default UOM for pre-order items
          brewery: preOrderItem.brewery,
          description: preOrderItem.description,
          preOrderItemId: preOrderItem.preOrderItemId
        })));
      } catch (error) {
        console.error('Error fetching open pre-order items:', error);
      }
  };

  const addItems = () => {
    fetchAuthorizedItems();
  };

  const setBaseUOMDefaultIfUndefined = (item) => {
    console.log('setBaseUOMDefaultIfUndefined', item.baseUnitOfMeasure);
    if (!item.baseUnitOfMeasure) {
      console.log('!item.baseUnitOfMeasure');
      if (item.salesRule) {
        switch (item.salesRule) {
          case 0:
            item.baseUnitOfMeasure = 'PALLET';
            break;
          case 1:
            item.baseUnitOfMeasure = 'LAYER';
            break;
          case 2:
            item.baseUnitOfMeasure = 'PIECE';
            break;
        }
      } else {
        item.baseUnitOfMeasure = 'PALLET';
      }
      console.log('setBaseUOMDefaultIfUndefined assigning');
    }
    console.log('setBaseUOMDefaultIfUndefined assigned', item);
  }

  const handleSelectChange = (item, event) => {
    const selectedUOM = event.target.value;
    const inputValue = document.getElementById(`input-${item.no_}`).value;
  
    setSelectedItems(prevSelectedItems => {
      const existingItem = prevSelectedItems.find(i => i.no_ === item.no_);
      if (existingItem) {
        return prevSelectedItems.map(i =>
          i.no_ === item.no_ ? { ...i, qty: inputValue, uom: selectedUOM } : i
        );
      } else {
        return [...prevSelectedItems, { no_: item.no_, qty: inputValue, uom: selectedUOM }];
      }
    });
  }

  const calculateTotalUnits = (item, qty, uom) => {
    //console.log('calculateTotalUnits', item, qty, uom);
    if (uom === 'LAYER') {
      //console.log('LAYER calc', qty, item.qtyPerLayerNotDivided, qty * item.qtyPerLayerNotDivided);
      return qty * item.qtyPerLayerNotDivided;
    } else if (uom === 'PALLET') {
      //console.log('PALLET calc', qty, AuthorizedItems.find(authItem => authItem.no_ === item.no_)?.qtyPerPalletNotDivided, qty * AuthorizedItems.find(authItem => authItem.no_ === item.no_)?.qtyPerPalletNotDivided);
      //console.log('PALLET calc', qty, AuthorizedItems.find(authItem => authItem.no_ === item.no_)?.qtyPerPalletNotDivided, qty * AuthorizedItems.find(authItem => authItem.no_ === item.no_)?.qtyPerPalletNotDivided);
      //console.log('PALLET qrtPerPalletNotDivided', item.qtyPerPalletNotDivided);
      return qty * item.qtyPerPalletNotDivided;
    } else {
      //console.log('PIECE calc', qty, qty);
      return qty;
    }
  };

  const handleDeleteOrder = async (orderId) => {
    console.log('handleDeleteItem orderId: ', orderId);
    setSubmittingOrder(true);
    try {
      const response = await fetch(`${ApiBaseUrl}/api/sales/${orderId}/DeleteECommOrder_ByOrderId`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to delete order');
      }

      // Reset order state
      setOrderHeaderData(null);
      setOrderLinesData(null);
      setSelectedItems([]);
      setShowAddItems(true);
      handleOrderDeleted();

      // Optionally, you can add a success message here
      console.log('Order deleted successfully');
    } catch (error) {
      console.error('Error deleting order:', error);
      // Optionally, you can add an error message here
    } finally {
      setSubmittingOrder(false);
    }
  }

  const [breweryFilter, setBreweryFilter] = useState('');
  const [descriptionFilter, setDescriptionFilter] = useState('');
  const [breweryInput, setBreweryInput] = useState('');
  const [descriptionInput, setDescriptionInput] = useState('');

  const debouncedSetBreweryFilter = useCallback(
    value => {
      const timeoutId = setTimeout(() => {
        setBreweryFilter(value);
      }, 300); // 300ms delay

      return () => clearTimeout(timeoutId);
    },
    []
  );

  const debouncedSetDescriptionFilter = useCallback(
    value => {
      const timeoutId = setTimeout(() => {
        setDescriptionFilter(value);
      }, 300); // 300ms delay

      return () => clearTimeout(timeoutId);
    },
    []
  );

  useEffect(() => {
    const cleanup = debouncedSetBreweryFilter(breweryInput);
    return cleanup;
  }, [breweryInput, debouncedSetBreweryFilter]);

  useEffect(() => {
    const cleanup = debouncedSetDescriptionFilter(descriptionInput);
    return cleanup;
  }, [descriptionInput, debouncedSetDescriptionFilter]);

  const filteredAuthorizedItems = AuthorizedItems ? AuthorizedItems.filter(item => 
    item.brewery.toLowerCase().includes(breweryFilter.toLowerCase()) &&
    item.description.toLowerCase().includes(descriptionFilter.toLowerCase())
  ) : [];

  const handleEditClick = () => {
    setReviewingOrder(false);
    setIsEditing(true);
    fetchAuthorizedItems();
    setForRealEditing(true);
    //set sesion storage variable isEditing to true, add it if it doesn't exist
    sessionStorage.setItem('isEditing', 'true');
    // Optionally, you can add any additional logic needed to transition back to editing
  };

  return (
    <Grid container spacing={1}>
      {ShowOrderSubmmited ? 
        <>
          <div style={{textAlign: 'center', width: '100%', margin: 'auto', marginTop: '64px'}}>
            <Typography>
              Thank you for submitting your order. Please go back to the DASHBOARD to reset this page.
              <div>You will receive a confirmation email shortly.</div>
            </Typography>
          </div>
        </> :
      <>
      <Grid item xs={12} md={3}>
        <Paper style={{ minHeight: '290px'}} elevation={3} sx={{ p: 2 }}>
          <div style={{borderBottom: '1px solid grey'}}>
            <Typography variant="h6" color="error" gutterBottom style={{display: 'inline-block'}}>
              Your order
            </Typography>
            {orderHeaderData && !isNaN(parseInt(orderHeaderData.orderId)) && (
              <span style={{float: 'right'}}>
                <DeleteIcon 
                  style={{ cursor: 'pointer', color: 'grey' }} 
                  onClick={() => handleDeleteOrder(orderHeaderData.orderId)}
                />
              </span>
            )}
          </div>
          
          <Grid container spacing={1}>
            {orderHeaderData && Object.keys(orderHeaderData).length > 0 ? (
              <Grid container spacing={1} style={{marginTop: '16px'}}>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary" align="right">
                    DUSA SOR No:
                  </Typography>
                </Grid>
                <Grid item xs={6} align="left">
                  <Typography variant="body2">
                    {isNaN(parseInt(orderHeaderData.orderId)) ? orderHeaderData.orderId : "Pending SOR"}
                  </Typography>
                </Grid>
                <Grid item xs={6} align="right">
                  <Typography variant="body2" color="text.secondary">
                    Cust PO No:
                  </Typography>
                </Grid>
                <Grid item xs={6} align="left">
                  <Typography variant="body2">
                    {orderHeaderData.yourOrderNo}
                  </Typography>
                </Grid>
                <Grid item xs={6} align="right">
                  <Typography variant="body2" color="text.secondary">
                    Status:
                  </Typography>
                </Grid>
                <Grid item xs={6} align="left">
                  <Typography variant="body2">
                    {(() => {
                      switch(orderHeaderData.status) {
                        case "0":
                          return "Open";
                        case "1":
                          return "Released";
                        default:
                          return orderHeaderData.status;
                      }
                    })()}
                  </Typography>
                </Grid>

                <Grid item xs={6} align="right">
                  <Typography variant="body2" color="text.secondary">
                    Requested ship date:
                  </Typography>
                </Grid>
                <Grid item xs={6} align="left">
                  <Typography variant="body2">
                    {new Date(orderHeaderData.requestedDeliveryDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    })}
                  </Typography>
                </Grid>

                <Grid item xs={6} align="right">
                  <Typography variant="body2" color="text.secondary">
                    Warehouse location:
                  </Typography>
                </Grid>
                <Grid item xs={6} align="left">
                  <Typography variant="body2">
                    {orderHeaderData.warehouseLocation}
                  </Typography>
                </Grid>

                <Grid item xs={6} align="right">
                  <Typography variant="body2" color="text.secondary">
                    Freight arranged by:
                  </Typography>
                </Grid>
                <Grid item xs={6} align="left">
                  <Typography variant="body2">
                  {(() => {
                    switch (orderHeaderData.freightArrangedBy) {
                      case "0":
                        return "You";
                      case "1":
                        return "Duvel USA";
                      default:
                        return orderHeaderData.freightArrangedBy;
                    }
                  })()}
                  </Typography>
                </Grid>

                <Grid item xs={6} align="right">
                  <Typography variant="body2" color="text.secondary">
                    Created on:
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                <Typography variant="body2" align="left">
                  {new Date(orderHeaderData.orderdate).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  })}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Box
                  sx={{
                    border: '1px solid #d0d0d0',
                    borderRadius: '8px',
                    px: 1.5,
                    py: 1,
                    mx: 1,
                    mt: 1.5,
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={6} align="right">
                      <Typography variant="body2" color="text.secondary">
                        Total product weight:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} align="left">
                      <Typography variant="body2">
                        {`${totalProductWeight.toFixed(2)} lbs`}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} align="right">
                      <Typography variant="body2" color="text.secondary">
                        Estimated pallet count:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} align="left">
                      <Typography variant="body2">
                        {roundedPalletsNeeded}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} align="right">
                      <Typography variant="body2" color="text.secondary">
                        Pallets weight:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} align="left">
                      <Typography variant="body2">
                        {`${palletsWeight.toFixed(2)} lbs`}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} align="right">
                      <Typography variant="body2" color="text.secondary">
                        Total order weight:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} align="left">
                      <Typography variant="body2">
                        {`${recalculatedTotalOrderWeight.toFixed(2)} lbs`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
            ) : (
              <Typography style={{ }} variant="body2" color="text.secondary">
                <div style={{marginLeft: '96px', marginTop: '106px'}}>
                  <p>Loading... this will take a few seconds... </p>
                  <LinearProgress style={{marginTop: '24px'}} color="secondary" />
                </div>
              </Typography>
            )}
          </Grid>
        </Paper>
        <div>
          {/* <>
            {reviewingOrder}
            -
            {orderLinesData}
            -
            {selectedItems.length}
          </> */}
          {!isLoading && (
            <>
              {reviewingOrder || isEditing ? (
                <div>
                  {!isEditing && (
                    <a 
                      style={{display: 'block', textAlign: 'center', margin: '24px auto', cursor: 'pointer', background: 'lightgrey', height: '24px', border: '2px solid black'}}
                      onClick={handleContinueEditingClick}
                    >
                      Continue Editing Order
                    </a>
                  )}
                  {SubmittingOrder ? (
                    <div style={{ textAlign: 'center', margin: '24px auto' }}>
                      Submitting order, please wait...
                    </div>
                  ) : (
                    <button 
                      style={{
                        height: '64px', 
                        width: '100%', 
                        margin: 'auto', 
                        marginTop: '24px', 
                        backgroundColor: 'lightgreen', 
                        color: 'black', 
                        cursor: 'pointer'
                      }}
                      onClick={handleSubmitOrderClick}
                    >
                      Submit Order
                    </button>
                  )}
                </div>
              ) : selectedItems && selectedItems.length > 0 ? (
                <button 
                  style={{height: '64px', width: '100%', margin: 'auto', marginTop: '24px', backgroundColor: 'lightgreen', color: 'black', cursor: 'pointer'}}
                  onClick={handleReviewClick}
                >
                  Review Order
                </button>
              ) : (
                <div>
                  {!orderLinesData && (
                    <a 
                      style={{display: 'block', textAlign: 'center', margin: '24px auto', cursor: 'pointer'}}
                      onClick={handleContinueEditingClick}
                    >
                      Continue Editing Order
                    </a>
                  )}
                  {!SubmittingOrder && !orderLinesData ? (
                    <button 
                      style={{
                        height: '64px', 
                        width: '100%', 
                        margin: 'auto', 
                        marginTop: '24px', 
                        backgroundColor: 'lightgreen', 
                        color: 'black', 
                        cursor: 'pointer'
                      }}
                      onClick={handleSubmitOrderClick}
                    >
                      Submit Order
                    </button>
                  ) : (
                    !orderLinesData && (
                      <div style={{ textAlign: 'center', margin: '24px auto' }}>
                        Submitting order, please wait...
                      </div>
                    )
                  )}
                  {Number.isInteger(parseInt(orderHeaderData.orderId)) && (!isEditing && selectedItems.length === 0 && orderLinesData.length > 0) && (
                    <button 
                      style={{
                        height: '64px', 
                        width: '100%', 
                        margin: 'auto', 
                        marginTop: '24px', 


                        backgroundColor: 'red', 
                        color: 'white', 
                        cursor: 'pointer'
                      }}
                      onClick={handleEditClick}
                    >Edit Order
                    </button>
                  )}
                </div>
              )}

            </>
          )}
        
        </div>
      </Grid>

      <Grid item xs={12} md={9} style={{maxHeight: '750px'}}>
        {/* <div>is editing: {isEditing ? 'true' : 'false'}</div>
        <div>forRealEditing: {forRealEditing ? 'true' : 'false'}</div> */}
        <Paper elevation={3} sx={{ p: 2, height: '100%', display: 'block', overflow: 'scroll', justifyContent: 'center', alignItems: 'center' }}>
          {isEditing && (
            <>
              {/* <>edit time</> */}
              {/* <OrderEdit 
                filteredAuthorizedItems={filteredAuthorizedItems}
                selectedItems={selectedItems} 
                setSelectedItems={setSelectedItems} 
                handleInputChange={handleInputChange}
              /> */}
            </>
          )}
          {/* I want this section hidden if isEditing is true */}
          {orderLinesData && orderLinesData.length && !isEditing > 0 ? (
            <div className="order-lines" style={{marginBottom: '20px'}}>
              {/* <h3>Order Lines</h3> */}
              <table className="min-w-full bg-white" style={{width: '90%', marginBottom: '20px'}}>
                <thead className="bg-gray-200">
                  <tr>
                    <th className="py-2 px-4 text-left">Item No.</th>
                    <th className="py-2 px-4 text-left">Description</th>
                    <th className="py-2 px-4 text-left">Quantity</th>
                    <th className="py-2 px-4 text-left">Unit of Measure</th>
                    {/* <th className="py-2 px-4 text-left">Unit Price</th> */}
                    <th className="py-2 px-4 text-left">Weight</th>
                  </tr>
                </thead>
                <tbody>
                  {orderLinesData.map((line, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}>
                      <td className="py-2 px-4">{line.itemNo_}</td>
                      <td className="py-2 px-4">{line.description}</td>
                      <td className="py-2 px-4">{line.numberOfUnits}</td>
                      <td className="py-2 px-4">{line.unitOfMeasure}</td>
                      {/* <td className="py-2 px-4">${line.unitPrice}</td> */}
                      <td className="py-2 px-4">{line.weight} lbs</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            null
          )}
          
{/*I want this section shown if isEditing is true, but also shown the way it is already shown too when there is just a new order being edited */}
{/* {<>Auth items: {AuthorizedItems ? AuthorizedItems.length : 0}</>} */}
          {/* {AuthorizedItems && AuthorizedItems.length > 0 || isEditing && orderLinesData && orderLinesData.length > 0 ? ( */}
          {AuthorizedItems && AuthorizedItems.length > 0 ? (
            <Typography variant="body1" gutterBottom>
              {/* <>'here we are'</> */}
              
              
              <div className="" style={{width: '100%', margin: 'auto', padding: 0}}>
                <table className="min-w-full bg-white" style={{width: '90%'}}>
                  <thead className="bg-red-600 text-white">
                    <tr>
                      <th className="py-2 px-4 text-left" style={{ width: '12%' }}>Brewery</th>
                      <th className="py-2 px-4 text-left" style={{ width: '8%' }}>Format</th>
                      <th className="py-2 px-4 text-left" style={{ width: '8%' }}>Size</th>
                      <th className="py-2 px-4 text-left" style={{ width: '10%' }}>Item No.</th>
                      <th className="py-2 px-4 text-left" style={{ width: '30%', minWidth: '380px' }}>Description</th>
                      <th className="py-2 px-4 text-left" style={{ width: '8%' }}>Qty</th>
                      <th className="py-2 px-4 text-left" style={{ width: '8%' }}>UOM</th>
                      <th className="py-2 px-4 text-left" style={{ width: '8%' }}>Total Units</th>
                      <th className="py-2 px-4 text-left" style={{ width: '8%' }}>Total Weight</th>
                    </tr>
                    {/* region #search inputs */}
                    <tr>
                      <th className="py-2 px-4 text-left">
                        <input
                          type="text"
                          placeholder="Search Brewery"
                          value={breweryInput}
                          onChange={(e) => setBreweryInput(e.target.value)}
                          style={{ width: '100%', padding: '5px', color: 'black' }}
                        />
                      </th>
                      <th />
                      <th />
                      <th />
                      <th className="py-2 px-4 text-left">
                        <input
                          type="text"
                          placeholder="Search Description"
                          value={descriptionInput}
                          onChange={(e) => setDescriptionInput(e.target.value)}
                          style={{ width: '100%', padding: '5px', color: 'black' }}
                        />
                      </th>
                      <th />
                      <th />
                      <th />
                      <th />
                    </tr>
                    {/* #endregion */}
                  </thead>
                  <tbody>


                  {filteredAuthorizedItems.filter(item => !reviewingOrder || selectedItems.some(i => i.no_ === item.no_)).map((item, index) => {
                    {/*}
                    // const selectedItem = isEditing 
                    //   ? orderLinesData.find(i => i.itemNo_ === item.no_)
                    //   : selectedItems.find(i => i.no_ === item.no_);
                    // const qty = isEditing
                    //   ? (selectedItem ? selectedItem.numberOfUnits : '')
                    //   : (selectedItem ? selectedItem.qty : '');
                    // const uom = isEditing  
                    //   ? (selectedItem ? selectedItem.unitOfMeasure : '')
                    //   : (selectedItem ? selectedItem.uom : '');
                    */}
                      const selectedItem = selectedItems.find(i => i.no_ === item.no_);
                      //console.log('selectedItem inside the filteredAuthItems or selectedItems.some: ', selectedItem);
                      const qty = selectedItem ? selectedItem.qty : '';
                      const uom = selectedItem ? selectedItem.uom : '';
                    return (
                      <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : 'bg-white'} style={{ fontSize: '11px' }}>
                        <td className="py-2 px-4">{item.brewery}</td>
                        <td className="py-2 px-4">{item.format}</td>
                        <td className="py-2 px-4">{item.packageSizeCode}</td>
                        <td className="py-2 px-4" style={{fontSize: '14px'}}>{item.no_}</td>
                        <td className="py-2 px-4" style={{ 
                          textAlign: 'left', 
                          fontSize: '14px', 
                          paddingLeft: '16px', 
                          position: 'relative',
                          width: '30%',
                          minWidth: '380px',
                          whiteSpace: 'normal',
                          wordWrap: 'break-word'
                        }}>
                          {item.description}
                          {item.seasonalAllocation && (
                            <span style={{ fontStyle: 'italic', float: 'right' }}>(Pre-Order)</span>
                          )}
                        </td>

                        
                        {/* #region Old Input */}
                         {/* <td>
                          <input
                            id={`input-${item.no_}`}
                            style={{ width: '30px' }}
                            onChange={(event) => handleInputChange(item, event)}
                            type="number"
                            min="0"
                            step="1"
                            disabled={item.seasonalAllocation || reviewingOrder}
                            value={item.seasonalAllocation 
                                    ? (OpenPreOrderItems.find(preOrderItem => 
                                        preOrderItem.no_ === item.no_ && preOrderItem.firstShipDate === OrderCycleInfo.minShipDate
                                      )?.preOrderQty || 0)
                                    : qty
                                  }/>
                        </td> */}
                        {/* #endregion */}

                        <td className="py-2 px-4">
                          <input
                            id={`input-${item.no_}`}
                            style={{ 
                              width: '60px', 
                              borderColor: invalidItems.includes(item.no_) ? 'red' : 'initial' 
                            }}
                            onChange={(event) => handleInputChange(item, event)}
                            type="number"
                            min="1"
                            step="1"
                            disabled={item.seasonalAllocation || (!isEditing && reviewingOrder)}
                            value={item.seasonalAllocation ? (OpenPreOrderItems.find(preOrderItem => 
                              preOrderItem.no_ === item.no_)?.preOrderQty || 0) : qty}
                          />
                        </td>

                        <td className="py-2 px-4">
                          <select 
                            id={`select-${item.no_}`} 
                            onChange={(event) => handleSelectChange(item, event)}
                            disabled={item.seasonalAllocation || reviewingOrder}
                            value={item.seasonalAllocation ? "PIECE" : uom}
                            style={{ borderColor: invalidItems.includes(item.no_) ? 'red' : 'initial' }}
                          >
                            <option value=""></option>
                            <option value="PALLET">Pallet</option>
                            {(item.salesRule === 2 || item.salesRule === 1) && item.format !== 'DRAFT' ? 
                              <option value="LAYER">Layer</option> : null}
                            {item.salesRule === 2 ? 
                              <option value="PIECE">Piece</option> : null}
                          </select>
                        </td>


                        {/* total units */}
                        <td className="py-2 px-4" style={{fontWeight: '900'}}>
                          <span>{selectedItem && selectedItem.uom ? calculateTotalUnits(item, selectedItem.qty, selectedItem.uom) : null} </span><span>{selectedItem && selectedItem.uom ? 'pieces' : null}</span>
                        </td>

                        {/* total weight */}
                        <td className="py-2 px-4" style={{fontWeight: '900'}}>
                          {selectedItem && selectedItem.uom && calculateTotalUnits(item, selectedItem.qty, selectedItem.uom) > 0 
                            ? parseFloat(item.weight * calculateTotalUnits(item, selectedItem.qty, selectedItem.uom)).toFixed(2) 
                            : null}
                        </td>
                      </tr>
                    );
                  })}

                    
                  </tbody>
                </table>
              </div>
            </Typography>
          ) : (
            <>
              
              {showAddItems && !isEditing && (
                <>
                  <Typography style={{paddingTop: '64px', marginBottom: '32px'}} variant="body1" gutterBottom>
                    You have no items on this order yet!
                  </Typography>
                  <Button variant="contained" color="error" sx={{ mt: 2 }} onClick={addItems}>
                    ADD ITEMS
                  </Button>
                </>
              )}
            </>
          )}
        </Paper>
      </Grid>

      </>}
    </Grid>
  );
};

export default OrderDetails;

{/* {AuthorizedItems.map((item, index) => (
                      <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : 'bg-white'} style={{ fontSize: '11px' }}>
                      <td className="py-2 px-4">{item.brewery}</td>
                      <td className="py-2 px-4">{item.format}</td>
                      <td className="py-2 px-4">{item.packageSizeCode}</td>
                      <td className="py-2 px-4" style={{fontSize: '14px'}}>{item.no_}</td>
                        <td className="py-2 px-4" style={{ textAlign: 'left', fontSize: '14px', paddingLeft: '16px', position: 'relative' }}>
                          {item.description}
                          {item.seasonalAllocation && (
                            <span style={{ fontStyle: 'italic', float: 'right' }}>(Pre-Order)</span>
                          )}
                        </td>

                        <td className="py-2 px-4">
                          <input
                            id={`input-${item.no_}`}
                            style={{ width: '30px' }}
                            onChange={(event) => handleInputChange(item, event)}
                            type="number"
                            min="0"
                            step="1"
                            disabled={item.seasonalAllocation}
                          />
                        </td>

                        <td className="py-2 px-4">
                          <select 
                            id={`select-${item.no_}`} 
                            onChange={(event) => handleSelectChange(item, event)}
                            disabled={item.seasonalAllocation}
                          >
                            <option value=""></option>
                            <option value="PALLET">Pallet</option>
                            {(item.salesRule === 2 || item.salesRule === 1) && item.format !== 'DRAFT' ? 
                              <option value="LAYER">Layer</option> : null}
                            {item.salesRule === 2 ? 
                              <option value="PIECE">Piece</option> : null}
                          </select>
                        </td>

                      <td className="py-2 px-4" style={{fontWeight: '900'}}>
                        {selectedItems.find(i => i.no_ === item.no_ && i.uom) ? calculateTotalUnits(item, selectedItems.find(i => i.no_ === item.no_).qty, selectedItems.find(i => i.no_ === item.no_).uom) : null}
                        
                      </td>
                      <td className="py-2 px-4" style={{fontWeight: '900'}}>
                        
                        {selectedItems.find(i => i.no_ === item.no_ && i.uom) && calculateTotalUnits(item, selectedItems.find(i => i.no_ === item.no_).qty, selectedItems.find(i => i.no_ === item.no_).uom) > 0 
                          ? parseFloat(item.weight * calculateTotalUnits(item, selectedItems.find(i => i.no_ === item.no_).qty, selectedItems.find(i => i.no_ === item.no_).uom)).toFixed(2) 
                          : null}
                      </td>
                    </tr>
                    ))} */}